"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCloneAndAttachProductTree = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const get_catalogs_query_1 = require("../../catalog/get-catalogs.query");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const product_tree_node_1 = require("../../product-tree-node");
const attach_product_tree_to_catalog_mutation_1 = require("../attach-product-tree-to-catalog.mutation");
const gql_1 = require("../gql");
const store_1 = require("../../../../store");
const useCloneAndAttachProductTree = () => {
    const [cloneProductTreeMutation] = (0, react_2.useMutation)(gql_1.CLONE_PRODUCT_TREE);
    const [attachProductTreeToCatalogMutation] = (0, react_2.useMutation)(attach_product_tree_to_catalog_mutation_1.ATTACH_PRODUCT_TREE_TO_CATALOG);
    const projectId = (0, store_1.useSelectedProjectId)();
    const client = (0, react_2.useApolloClient)();
    const cloneAndAttachProductTreeToCatalog = (0, react_1.useCallback)((options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { variables: { productTreeId, title, catalogId, }, } = options;
        const cloneProductTreeResponse = yield cloneProductTreeMutation({ variables: { productTreeId, title } });
        (0, client_utils_1.genericGraphQLErrorsHandler)(cloneProductTreeResponse);
        const { id } = ((_a = cloneProductTreeResponse.data.cloneProductTree) === null || _a === void 0 ? void 0 : _a.productTree) || {};
        client.cache.gc();
        const attachProductTreeToCatalogResponse = yield attachProductTreeToCatalogMutation(Object.assign(Object.assign({}, options), { variables: Object.assign(Object.assign({}, options.variables), { catalogId, productTreeId: id }), refetchQueries: (response) => {
                const { root: { id } } = response.data.editProductTree.productTree;
                return [
                    { query: gql_1.GET_PRODUCT_TREE, variables: { nodeId: id, catalogId } },
                    { query: product_tree_node_1.GET_PRODUCT_TREE_NODE_WITH_ONE_CHILD_LEVEL, variables: { nodeId: id, catalogId } },
                    {
                        query: get_catalogs_query_1.GET_CATALOGS,
                        variables: {
                            projectId,
                            sort: [{ createdAt: graphql_1.OrderBy.Desc }],
                            first: client_constants_1.PAGE_SIZE_EXTRA_LARGE,
                        },
                    },
                ];
            }, awaitRefetchQueries: true }));
        (0, client_utils_1.genericGraphQLErrorsHandler)(attachProductTreeToCatalogResponse);
        return attachProductTreeToCatalogResponse;
    }), [attachProductTreeToCatalogMutation, client.cache, cloneProductTreeMutation, projectId]);
    return {
        cloneAndAttachProductTreeToCatalog,
    };
};
exports.useCloneAndAttachProductTree = useCloneAndAttachProductTree;
